"use client";

import { useMemo } from "react";

import { useInstruments } from "#/services/kyan/hooks/useInstruments";
import { useMaturity } from "#/store/options/page/maturity";
import { type Market } from "#/types/markets";
import { getOptionInstrumentProperties } from "#/utils/instrument.utils";

export const useStrikes = (maturity?: string, market?: Market) => {
  const { maturity: currentMaturity } = useMaturity();
  const { data, isLoading, refetch } = useInstruments(market);

  const effectiveMaturity = maturity || currentMaturity;

  const strikes = useMemo(() => {
    return Array.from(
      new Set(
        data
          .map((item) => getOptionInstrumentProperties(item))
          .filter((item) => item.maturity === effectiveMaturity)
          .map((item) => item.strike),
      ),
    ).sort((a, b) => a - b);
  }, [data, effectiveMaturity]);

  return {
    strikes,
    isLoading,
    refetch,
  };
};
